/**
 * Main navigation.
 *
 * Blog is intentionally absent from both the main navigation and the footer.
 * Blog articles are discoverable through the sitemap, search engines,
 * and internal links from service pages.
 */
export const NAV_ITEMS = [
    { label: "Home", path: "/" },
    {
        label: "Services",
        path: "/services",
        children: [
            { label: "Custom Website Development", path: "/services/custom-website-development" },
            { label: "Custom E-Commerce Development", path: "/services/custom-ecommerce-development" },
            { label: "POS & Inventory Systems", path: "/services/pos-inventory-systems" },
            { label: "Mobile Application Development", path: "/services/mobile-application-development" },
            { label: "Digital Marketing & Branding", path: "/services/digital-marketing-branding" },
            { label: "UI/UX Design", path: "/services/ui-ux-design" },
        ],
    },
    { label: "Work", path: "/work" },
    { label: "About", path: "/about" },
    { label: "D CODE ACADEMY", path: "/d-code-academy" },
];

/**
 * Primary call to action in the header.
 * Scrolls to the project enquiry form on the homepage.
 */
export const NAV_CTA = {
    label: "Get a Free Quote",
    path: "/#enquiry",
};

export const FOOTER_LINKS = {
    services: [
        // The hub is listed first and linked from every page, so it accumulates
        // more internal links than any single service page. That is what makes
        // it the strongest sitelink candidate — one link covering all six.
        { label: "All Services", path: "/services" },
        { label: "Custom Website Development", path: "/services/custom-website-development" },
        { label: "Custom E-Commerce Development", path: "/services/custom-ecommerce-development" },
        { label: "POS & Inventory Systems", path: "/services/pos-inventory-systems" },
        { label: "Mobile Application Development", path: "/services/mobile-application-development" },
        { label: "Digital Marketing & Branding", path: "/services/digital-marketing-branding" },
        { label: "UI/UX Design", path: "/services/ui-ux-design" },
    ],
    company: [
        { label: "About Us", path: "/about" },
        { label: "Our Work", path: "/work" },
        { label: "Work With Us", path: "/about#work-with-us" },
        { label: "Internships", path: "/about#internships" },
    ],
    resources: [
        { label: "D CODE ACADEMY", path: "/d-code-academy" },
        { label: "Get a Free Quote", path: "/#enquiry" },
        { label: "FAQ", path: "/#faq" },
    ],
    legal: [
        { label: "Privacy Policy", path: "/privacy-policy" },
        { label: "Terms & Conditions", path: "/terms-and-conditions" },
    ],
};
